export var APPLICATION_FLOW;
(function (APPLICATION_FLOW) {
  APPLICATION_FLOW["PURCHASE"] = "purchase-approval";
  APPLICATION_FLOW["PRE_APPROVAL"] = "purchase-preapproval";
  APPLICATION_FLOW["REFINANCE"] = "refinance-approval";
  APPLICATION_FLOW["SWITCH_TRANSFER"] = "switch-transfer";
})(APPLICATION_FLOW || (APPLICATION_FLOW = {}));
export var PROPERTY_OCCUPANCY_TYPE;
(function (PROPERTY_OCCUPANCY_TYPE) {
  PROPERTY_OCCUPANCY_TYPE["OWNER_OCCUPIED"] = "owner-occupied";
  PROPERTY_OCCUPANCY_TYPE["OWNER_OCCUPIED_AND_RENTAL"] = "owner-occupied-and-rental";
  PROPERTY_OCCUPANCY_TYPE["RENTAL"] = "rental";
  PROPERTY_OCCUPANCY_TYPE["SECOND_HOME"] = "second-home";
})(PROPERTY_OCCUPANCY_TYPE || (PROPERTY_OCCUPANCY_TYPE = {}));
export var PROPERTY_STYLE;
(function (PROPERTY_STYLE) {
  PROPERTY_STYLE["ONE_STOREY"] = "one-storey";
  PROPERTY_STYLE["BI_LEVEL"] = "bi-level";
  PROPERTY_STYLE["TWO_STOREY"] = "two-storey";
  PROPERTY_STYLE["SPLIT_LEVEL"] = "split-level";
  PROPERTY_STYLE["STOREY_AND_A_HALF"] = "storey-and-a-half";
  PROPERTY_STYLE["THREE_STOREY"] = "three-storey";
  PROPERTY_STYLE["OTHER"] = "other";
})(PROPERTY_STYLE || (PROPERTY_STYLE = {}));
export var PROPERTY_TYPE;
(function (PROPERTY_TYPE) {
  PROPERTY_TYPE["DETACHED"] = "detached";
  PROPERTY_TYPE["SEMI_DETACHED"] = "semi-detached";
  PROPERTY_TYPE["ROW_HOUSING"] = "row-housing";
  PROPERTY_TYPE["DUPLEX_DETACHED"] = "duplex-detached";
  PROPERTY_TYPE["APARTMENT_LOW_RISE"] = "apartment-low-rise";
  PROPERTY_TYPE["APARTMENT_HIGH_RISE"] = "apartment-high-rise";
  PROPERTY_TYPE["MOBILE"] = "mobile";
  PROPERTY_TYPE["STACKED"] = "stacked";
})(PROPERTY_TYPE || (PROPERTY_TYPE = {}));
export var PROPERTY_GARAGE_STYLE;
(function (PROPERTY_GARAGE_STYLE) {
  PROPERTY_GARAGE_STYLE["DETACHED"] = "detached";
  PROPERTY_GARAGE_STYLE["ATTACHED"] = "attached";
})(PROPERTY_GARAGE_STYLE || (PROPERTY_GARAGE_STYLE = {}));
export var PROPERTY_GARAGE_SIZE;
(function (PROPERTY_GARAGE_SIZE) {
  PROPERTY_GARAGE_SIZE["SINGLE"] = "single";
  PROPERTY_GARAGE_SIZE["DOUBLE"] = "double";
  PROPERTY_GARAGE_SIZE["TRIPLE"] = "triple";
  PROPERTY_GARAGE_SIZE["NONE"] = "none";
})(PROPERTY_GARAGE_SIZE || (PROPERTY_GARAGE_SIZE = {}));
export var APPLICANT_SALUTATION;
(function (APPLICANT_SALUTATION) {
  APPLICANT_SALUTATION["MR"] = "mr.";
  APPLICANT_SALUTATION["MRS"] = "mrs.";
  APPLICANT_SALUTATION["MS"] = "ms.";
  APPLICANT_SALUTATION["DR"] = "dr.";
  APPLICANT_SALUTATION["REV"] = "rev.";
  APPLICANT_SALUTATION["MISS"] = "miss";
  APPLICANT_SALUTATION["JUDGE"] = "judge";
})(APPLICANT_SALUTATION || (APPLICANT_SALUTATION = {}));
export var APPLICANT_MARITAL_STATUS;
(function (APPLICANT_MARITAL_STATUS) {
  APPLICANT_MARITAL_STATUS["SINGLE"] = "single";
  APPLICANT_MARITAL_STATUS["MARRIED"] = "married";
  APPLICANT_MARITAL_STATUS["COMMON_LAW"] = "common-law";
  APPLICANT_MARITAL_STATUS["SEPARATED"] = "seperated";
  APPLICANT_MARITAL_STATUS["DIVORCED"] = "divorced";
  APPLICANT_MARITAL_STATUS["WIDOWED"] = "widowed";
  APPLICANT_MARITAL_STATUS["OTHER"] = "other";
})(APPLICANT_MARITAL_STATUS || (APPLICANT_MARITAL_STATUS = {}));
export var APPLICANT_RELATIONSHIP;
(function (APPLICANT_RELATIONSHIP) {
  APPLICANT_RELATIONSHIP["SPOUSE"] = "spouse";
  APPLICANT_RELATIONSHIP["COMMON_LAW"] = "common-law";
  APPLICANT_RELATIONSHIP["RELATED_FAMILY_MEMBER"] = "related-family-member";
  APPLICANT_RELATIONSHIP["PARENT"] = "parent";
  APPLICANT_RELATIONSHIP["SIBLING"] = "sibling";
  APPLICANT_RELATIONSHIP["CHILD"] = "child";
  APPLICANT_RELATIONSHIP["GRANDCHILD"] = "grandchild";
  APPLICANT_RELATIONSHIP["GRANDPARENT"] = "grandparent";
  APPLICANT_RELATIONSHIP["OTHER"] = "other";
})(APPLICANT_RELATIONSHIP || (APPLICANT_RELATIONSHIP = {}));
export var APPLICANT_LANGUAGE_PREFERENCE;
(function (APPLICANT_LANGUAGE_PREFERENCE) {
  APPLICANT_LANGUAGE_PREFERENCE["ENGLISH"] = "english";
  APPLICANT_LANGUAGE_PREFERENCE["FRENCH"] = "french";
})(APPLICANT_LANGUAGE_PREFERENCE || (APPLICANT_LANGUAGE_PREFERENCE = {}));
export var APPLICANT_TYPE;
(function (APPLICANT_TYPE) {
  APPLICANT_TYPE["APPLICANT"] = "applicant";
  APPLICANT_TYPE["CO_SIGNER"] = "co-signer";
  APPLICANT_TYPE["GUARANTOR"] = "guarantor";
})(APPLICANT_TYPE || (APPLICANT_TYPE = {}));
export var APPLICANT_LIVING_SITUATION;
(function (APPLICANT_LIVING_SITUATION) {
  APPLICANT_LIVING_SITUATION["OWN"] = "own";
  APPLICANT_LIVING_SITUATION["RENT"] = "rent";
  APPLICANT_LIVING_SITUATION["LIVE_WITH_PARENTS"] = "live-with-parents";
  APPLICANT_LIVING_SITUATION["OTHER"] = "other";
})(APPLICANT_LIVING_SITUATION || (APPLICANT_LIVING_SITUATION = {}));
export var APPLICANT_IDENTIFICATION_TYPE;
(function (APPLICANT_IDENTIFICATION_TYPE) {
  APPLICANT_IDENTIFICATION_TYPE["BIRTH_CERT"] = "birth-cert";
  APPLICANT_IDENTIFICATION_TYPE["DRIVERS_LICENSE"] = "drivers-license";
  APPLICANT_IDENTIFICATION_TYPE["SOCIAL_INS_CARD"] = "social-ins-card";
  APPLICANT_IDENTIFICATION_TYPE["PASSPORT"] = "passport";
  APPLICANT_IDENTIFICATION_TYPE["HEALTH_INSURANCE_CARD"] = "health-ins-card";
  APPLICANT_IDENTIFICATION_TYPE["PR_CARD"] = "pr-card";
  APPLICANT_IDENTIFICATION_TYPE["CITIZENSHIP_CART"] = "citizenship-cert";
  APPLICANT_IDENTIFICATION_TYPE["IMM_1000"] = "imm-1000-imm-form";
  APPLICANT_IDENTIFICATION_TYPE["IMM_1442"] = "imm-1442-citizenship-and-imm-canada";
  APPLICANT_IDENTIFICATION_TYPE["OTHER"] = "other";
})(APPLICANT_IDENTIFICATION_TYPE || (APPLICANT_IDENTIFICATION_TYPE = {}));
export var APPLICANT_OPERATING_AS;
(function (APPLICANT_OPERATING_AS) {
  APPLICANT_OPERATING_AS["SOLE_PROPRIETORSHIP"] = "sole-proprietorship";
  APPLICANT_OPERATING_AS["PARTNERSHIP"] = "partnership";
  APPLICANT_OPERATING_AS["CORPORATION"] = "corporation";
})(APPLICANT_OPERATING_AS || (APPLICANT_OPERATING_AS = {}));
export var APPLICANT_EMPLOYMENT_TYPE;
(function (APPLICANT_EMPLOYMENT_TYPE) {
  APPLICANT_EMPLOYMENT_TYPE["FULL_TIME"] = "full-time";
  APPLICANT_EMPLOYMENT_TYPE["PART_TIME"] = "part-time";
  APPLICANT_EMPLOYMENT_TYPE["SEASONAL"] = "seasonal";
})(APPLICANT_EMPLOYMENT_TYPE || (APPLICANT_EMPLOYMENT_TYPE = {}));
export var APPLICANT_OCCUPATION;
(function (APPLICANT_OCCUPATION) {
  APPLICANT_OCCUPATION["SELF_EMPLOYED"] = "self-employed";
  APPLICANT_OCCUPATION["MANAGEMENT"] = "management";
  APPLICANT_OCCUPATION["CLERICAL"] = "clerical";
  APPLICANT_OCCUPATION["LABOUR_TRADESPERSON"] = "labour-tradesperson";
  APPLICANT_OCCUPATION["RETIRED"] = "retired";
  APPLICANT_OCCUPATION["PROFESSIONAL"] = "professional";
  APPLICANT_OCCUPATION["OTHER"] = "other";
})(APPLICANT_OCCUPATION || (APPLICANT_OCCUPATION = {}));
export var APPLICANT_INCOME_TYPE;
(function (APPLICANT_INCOME_TYPE) {
  APPLICANT_INCOME_TYPE["SALARY"] = "salary";
  APPLICANT_INCOME_TYPE["HOURLY"] = "hourly";
  APPLICANT_INCOME_TYPE["HOURLY_AND_COMMISSIONS"] = "hourly-and-commissions";
  APPLICANT_INCOME_TYPE["COMMISSIONS"] = "commissions";
  APPLICANT_INCOME_TYPE["SELF_EMPLOYED"] = "self-employed";
  APPLICANT_INCOME_TYPE["OTHER_EMPLOYMENT_INCOME"] = "other-employment-income";
})(APPLICANT_INCOME_TYPE || (APPLICANT_INCOME_TYPE = {}));
export var APPLICANT_INDUSTRY_SECTOR;
(function (APPLICANT_INDUSTRY_SECTOR) {
  APPLICANT_INDUSTRY_SECTOR["CONSTRUCTION"] = "construction";
  APPLICANT_INDUSTRY_SECTOR["GOVERNMENT"] = "government";
  APPLICANT_INDUSTRY_SECTOR["HEALTH"] = "health";
  APPLICANT_INDUSTRY_SECTOR["EDUCATION"] = "education";
  APPLICANT_INDUSTRY_SECTOR["HIGH_TECH"] = "high-tech";
  APPLICANT_INDUSTRY_SECTOR["RETAIL_SALES"] = "retail-sales";
  APPLICANT_INDUSTRY_SECTOR["LEISURE_ENTERTAINMENT"] = "leisure-entertainment";
  APPLICANT_INDUSTRY_SECTOR["BANKING_FINANCE"] = "banking-finance";
  APPLICANT_INDUSTRY_SECTOR["TRANSPORTATION"] = "transportation";
  APPLICANT_INDUSTRY_SECTOR["SERVICES"] = "services";
  APPLICANT_INDUSTRY_SECTOR["MANUFACTURING"] = "manufacturing";
  APPLICANT_INDUSTRY_SECTOR["FARMING_NATURAL_RESOURCES"] = "farming-natural-resources";
  APPLICANT_INDUSTRY_SECTOR["VARIES"] = "varies";
  APPLICANT_INDUSTRY_SECTOR["OTHER"] = "other";
})(APPLICANT_INDUSTRY_SECTOR || (APPLICANT_INDUSTRY_SECTOR = {}));
export var APPLICANT_INCOME_PERIOD;
(function (APPLICANT_INCOME_PERIOD) {
  APPLICANT_INCOME_PERIOD["ANNUAL"] = "annual";
  APPLICANT_INCOME_PERIOD["SEMI_ANNUAL"] = "semi-annual";
  APPLICANT_INCOME_PERIOD["QUARTERLY"] = "quarterly";
  APPLICANT_INCOME_PERIOD["MONTHLY"] = "monthly";
  APPLICANT_INCOME_PERIOD["SEMI_MONTHLY"] = "semi-monthly";
  APPLICANT_INCOME_PERIOD["BI_WEEKLY"] = "bi-weekly";
  APPLICANT_INCOME_PERIOD["WEEKLY"] = "weekly";
})(APPLICANT_INCOME_PERIOD || (APPLICANT_INCOME_PERIOD = {}));
export var ADDITIONAL_INCOME_TYPE;
(function (ADDITIONAL_INCOME_TYPE) {
  ADDITIONAL_INCOME_TYPE["CHILD_SUPPORT"] = "child-support";
  ADDITIONAL_INCOME_TYPE["PENSION"] = "pension";
  ADDITIONAL_INCOME_TYPE["INTEREST_INCOME"] = "interest-income";
  ADDITIONAL_INCOME_TYPE["ALIMONY"] = "alimony";
  ADDITIONAL_INCOME_TYPE["OTHER"] = "other";
})(ADDITIONAL_INCOME_TYPE || (ADDITIONAL_INCOME_TYPE = {}));
export var ASSET_TYPE;
(function (ASSET_TYPE) {
  ASSET_TYPE["SAVINGS"] = "savings";
  ASSET_TYPE["RRSP"] = "rrsp";
  ASSET_TYPE["GIFT"] = "gift";
  ASSET_TYPE["VEHICLE"] = "vehicle";
  ASSET_TYPE["STOCKS_BONDS_MUTUAL"] = "stocks-bonds-mutual";
  ASSET_TYPE["HOUSEHOLD_GOODS"] = "household-goods";
  ASSET_TYPE["LIFE_INSURANCE"] = "life-insurance";
  ASSET_TYPE["DEPOSIT_ON_PURCHASE"] = "deposit-on-purchase";
  ASSET_TYPE["OTHER"] = "other";
})(ASSET_TYPE || (ASSET_TYPE = {}));
export var LIABILITY_TYPE;
(function (LIABILITY_TYPE) {
  LIABILITY_TYPE["MORTGAGE"] = "mortgage";
  LIABILITY_TYPE["CREDIT_CARD"] = "credit-card";
  LIABILITY_TYPE["PERSONAL_LOAN"] = "personal-loan";
  LIABILITY_TYPE["AUTO_LOAN"] = "auto-loan";
  LIABILITY_TYPE["ALIMONY"] = "alimony";
  LIABILITY_TYPE["CHILD_SUPPORT"] = "child-support";
  LIABILITY_TYPE["STUDENT_LOAN"] = "student-loan";
  LIABILITY_TYPE["WAGE_GARNISHMENT"] = "wage-garnishment";
  LIABILITY_TYPE["UNSECURED_LINE_OF_CREDIT"] = "unsecured-line-of-credit";
  LIABILITY_TYPE["SECURED_LINE_OF_CREDIT"] = "secured-line-of-credit";
  LIABILITY_TYPE["INCOME_TAX"] = "income-tax";
  LIABILITY_TYPE["MORTGAGE_RENTAL_PROPERTY"] = "mortgage-rental-property";
  LIABILITY_TYPE["LEASE"] = "lease";
  LIABILITY_TYPE["AUTO_LEASE"] = "auto-lease";
  LIABILITY_TYPE["RENT"] = "rent";
  LIABILITY_TYPE["OTHER"] = "other";
})(LIABILITY_TYPE || (LIABILITY_TYPE = {}));
export var LIABILITY_PAYOFF;
(function (LIABILITY_PAYOFF) {
  LIABILITY_PAYOFF["PRIOR_TO_ADVANCE"] = "prior-to-advance";
  LIABILITY_PAYOFF["FROM_PROCEEDS"] = "from-proceeds";
  LIABILITY_PAYOFF["OTHER"] = "other";
})(LIABILITY_PAYOFF || (LIABILITY_PAYOFF = {}));
export var MORTGAGE_DOWNPAYMENT_SOURCE;
(function (MORTGAGE_DOWNPAYMENT_SOURCE) {
  MORTGAGE_DOWNPAYMENT_SOURCE["SALES_OF_EXISTING_PROPERTY"] = "sales-of-existing-property";
  MORTGAGE_DOWNPAYMENT_SOURCE["PERSONAL_CASH"] = "personal-cash";
  MORTGAGE_DOWNPAYMENT_SOURCE["RRSP"] = "rrsp";
  MORTGAGE_DOWNPAYMENT_SOURCE["BORROWED_AGAINST_LIQUID_ASSETS"] = "borrowed-against-liquid-assets";
  MORTGAGE_DOWNPAYMENT_SOURCE["GIFT"] = "gift";
  MORTGAGE_DOWNPAYMENT_SOURCE["SWEAT_EQUITY"] = "sweat-equity";
  MORTGAGE_DOWNPAYMENT_SOURCE["EXISTING_EQUITY"] = "existing-equity";
  MORTGAGE_DOWNPAYMENT_SOURCE["SECONDARY_FINANCING"] = "secondary-financing";
  MORTGAGE_DOWNPAYMENT_SOURCE["GRANTS"] = "grants";
  MORTGAGE_DOWNPAYMENT_SOURCE["OTHER"] = "other";
})(MORTGAGE_DOWNPAYMENT_SOURCE || (MORTGAGE_DOWNPAYMENT_SOURCE = {}));
export var MORTGAGE_REQUESTED_TYPE;
(function (MORTGAGE_REQUESTED_TYPE) {
  MORTGAGE_REQUESTED_TYPE["REQUESTED"] = "requested";
  MORTGAGE_REQUESTED_TYPE["EXISTING"] = "existing";
})(MORTGAGE_REQUESTED_TYPE || (MORTGAGE_REQUESTED_TYPE = {}));
export var MORTGAGE_LOAN_TYPE;
(function (MORTGAGE_LOAN_TYPE) {
  MORTGAGE_LOAN_TYPE["MORTGAGE"] = "mortgage";
  MORTGAGE_LOAN_TYPE["SECURED_LOC"] = "secured-loc";
})(MORTGAGE_LOAN_TYPE || (MORTGAGE_LOAN_TYPE = {}));
export var MORTGAGE_TYPE;
(function (MORTGAGE_TYPE) {
  MORTGAGE_TYPE["FIRST"] = "first";
  MORTGAGE_TYPE["SECOND"] = "second";
  MORTGAGE_TYPE["THIRD"] = "third";
})(MORTGAGE_TYPE || (MORTGAGE_TYPE = {}));
export var MORTGAGE_LINE_OF_BUSINESS;
(function (MORTGAGE_LINE_OF_BUSINESS) {
  MORTGAGE_LINE_OF_BUSINESS["A"] = "a";
  MORTGAGE_LINE_OF_BUSINESS["B"] = "b";
  MORTGAGE_LINE_OF_BUSINESS["C"] = "c";
})(MORTGAGE_LINE_OF_BUSINESS || (MORTGAGE_LINE_OF_BUSINESS = {}));
export var MORTGAGE_LOC_REPAYMENT;
(function (MORTGAGE_LOC_REPAYMENT) {
  MORTGAGE_LOC_REPAYMENT["FIVE_TWENTY"] = "5-20";
  MORTGAGE_LOC_REPAYMENT["TEN_FIFTEEN"] = "10-15";
})(MORTGAGE_LOC_REPAYMENT || (MORTGAGE_LOC_REPAYMENT = {}));
export var MORTGAGE_RATE_TYPE;
(function (MORTGAGE_RATE_TYPE) {
  MORTGAGE_RATE_TYPE["FIXED"] = "fixed";
  MORTGAGE_RATE_TYPE["ADJUSTABLE"] = "adjustable";
  MORTGAGE_RATE_TYPE["CAPPED_VARIABLE"] = "capped-variable";
  MORTGAGE_RATE_TYPE["VARIABLE"] = "variable";
  MORTGAGE_RATE_TYPE["BUY_DOWN"] = "buy-down";
})(MORTGAGE_RATE_TYPE || (MORTGAGE_RATE_TYPE = {}));
export var MORTGAGE_TERM_TYPE;
(function (MORTGAGE_TERM_TYPE) {
  MORTGAGE_TERM_TYPE["CLOSED"] = "closed";
  MORTGAGE_TERM_TYPE["OPEN"] = "open";
  MORTGAGE_TERM_TYPE["CONVERTIBLE"] = "convertible";
})(MORTGAGE_TERM_TYPE || (MORTGAGE_TERM_TYPE = {}));
export var MORTGAGE_FREQUENCY;
(function (MORTGAGE_FREQUENCY) {
  MORTGAGE_FREQUENCY["MONTHLY"] = "monthly";
  MORTGAGE_FREQUENCY["SEMI_MONTHLY"] = "semi-monthly";
  MORTGAGE_FREQUENCY["BIWEEKLY"] = "biweekly";
  MORTGAGE_FREQUENCY["ACCELERATED_BIWEEKLY"] = "accelerated-biweekly";
  MORTGAGE_FREQUENCY["WEEKLY"] = "weekly";
  MORTGAGE_FREQUENCY["ACCELERATED_WEEKLY"] = "accelerated-weekly";
})(MORTGAGE_FREQUENCY || (MORTGAGE_FREQUENCY = {}));
export var MORTGAGE_COMPOUNDING_PERIOD;
(function (MORTGAGE_COMPOUNDING_PERIOD) {
  MORTGAGE_COMPOUNDING_PERIOD["SEMI_ANNUALLY"] = "semi-annually";
  MORTGAGE_COMPOUNDING_PERIOD["MONTHLY"] = "monthly";
})(MORTGAGE_COMPOUNDING_PERIOD || (MORTGAGE_COMPOUNDING_PERIOD = {}));
export var MORTGAGE_NOTE_CATEGORY;
(function (MORTGAGE_NOTE_CATEGORY) {
  MORTGAGE_NOTE_CATEGORY["GENERAL"] = "general";
  MORTGAGE_NOTE_CATEGORY["ADMIN"] = "admin";
  MORTGAGE_NOTE_CATEGORY["SOURCE_OF_BUSINESS"] = "source-of-business";
  MORTGAGE_NOTE_CATEGORY["DECISIONING"] = "decisioning";
  MORTGAGE_NOTE_CATEGORY["MI_RESPONSE"] = "mi-response";
  MORTGAGE_NOTE_CATEGORY["DEAL_INGESTION"] = "deal-ingestion";
})(MORTGAGE_NOTE_CATEGORY || (MORTGAGE_NOTE_CATEGORY = {}));
export var MORTGAGE_PAYOFF;
(function (MORTGAGE_PAYOFF) {
  MORTGAGE_PAYOFF["PRIOR_TO_ADVANCE"] = "prior-to-advance";
  MORTGAGE_PAYOFF["FROM_PROCEEDS"] = "from-proceeds";
  MORTGAGE_PAYOFF["OTHER"] = "other";
})(MORTGAGE_PAYOFF || (MORTGAGE_PAYOFF = {}));
export var MORTGAGE_INSURANCE_PROVIDER;
(function (MORTGAGE_INSURANCE_PROVIDER) {
  MORTGAGE_INSURANCE_PROVIDER["CMHC"] = "cmhc";
  MORTGAGE_INSURANCE_PROVIDER["GENWORTH"] = "genworth";
  MORTGAGE_INSURANCE_PROVIDER["CANADA_GUARANTY"] = "canada-guaranty";
})(MORTGAGE_INSURANCE_PROVIDER || (MORTGAGE_INSURANCE_PROVIDER = {}));
export var PROPERTY_CONSTRUCTION_TYPE;
(function (PROPERTY_CONSTRUCTION_TYPE) {
  PROPERTY_CONSTRUCTION_TYPE["EXISTING"] = "existing";
  PROPERTY_CONSTRUCTION_TYPE["NEW"] = "new";
})(PROPERTY_CONSTRUCTION_TYPE || (PROPERTY_CONSTRUCTION_TYPE = {}));
export var PROPERTY_TENURE;
(function (PROPERTY_TENURE) {
  PROPERTY_TENURE["FREEHOLD"] = "freehold";
  PROPERTY_TENURE["LEASEHOLD"] = "leasehold";
  PROPERTY_TENURE["CONDO"] = "condo";
})(PROPERTY_TENURE || (PROPERTY_TENURE = {}));
export var PROPERTY_UNIT_OF_MEASUREMENT;
(function (PROPERTY_UNIT_OF_MEASUREMENT) {
  PROPERTY_UNIT_OF_MEASUREMENT["SQ_FT"] = "sq-ft";
  PROPERTY_UNIT_OF_MEASUREMENT["SQ_M"] = "sq-m";
  PROPERTY_UNIT_OF_MEASUREMENT["ACRES"] = "acres";
  PROPERTY_UNIT_OF_MEASUREMENT["HECTARES"] = "hectares";
})(PROPERTY_UNIT_OF_MEASUREMENT || (PROPERTY_UNIT_OF_MEASUREMENT = {}));
export var PROPERTY_HEATING_TYPE;
(function (PROPERTY_HEATING_TYPE) {
  PROPERTY_HEATING_TYPE["ELECTRIC_BASEBOARD"] = "electric-baseboard";
  PROPERTY_HEATING_TYPE["FORCED_AIR_GAS_OIL_ELEC"] = "forced-air-gas-oil-elec";
  PROPERTY_HEATING_TYPE["HOT_WATER_HEATING"] = "hot-water-heating";
  PROPERTY_HEATING_TYPE["OTHER"] = "other";
})(PROPERTY_HEATING_TYPE || (PROPERTY_HEATING_TYPE = {}));
export var PROPERTY_WATER_INFORMATION;
(function (PROPERTY_WATER_INFORMATION) {
  PROPERTY_WATER_INFORMATION["MUNICIPAL"] = "municipal";
  PROPERTY_WATER_INFORMATION["WELL"] = "well";
})(PROPERTY_WATER_INFORMATION || (PROPERTY_WATER_INFORMATION = {}));
export var PROPERTY_SEWAGE_TYPE;
(function (PROPERTY_SEWAGE_TYPE) {
  PROPERTY_SEWAGE_TYPE["MUNICIPAL"] = "municipal";
  PROPERTY_SEWAGE_TYPE["SEPTIC"] = "septic";
  PROPERTY_SEWAGE_TYPE["HOLDING_TANK"] = "holding-tank";
})(PROPERTY_SEWAGE_TYPE || (PROPERTY_SEWAGE_TYPE = {}));
export var PROPERTY_TAX_RESPONSIBLE;
(function (PROPERTY_TAX_RESPONSIBLE) {
  PROPERTY_TAX_RESPONSIBLE["BORROWER"] = "borrower";
  PROPERTY_TAX_RESPONSIBLE["LENDER"] = "lender";
})(PROPERTY_TAX_RESPONSIBLE || (PROPERTY_TAX_RESPONSIBLE = {}));
export var PROPERTY_RENTAL_INCOME;
(function (PROPERTY_RENTAL_INCOME) {
  PROPERTY_RENTAL_INCOME["NONE"] = "none";
  PROPERTY_RENTAL_INCOME["ADD_PERC_TO_GROSS_INCOME"] = "add-perc-to-gross-income";
  PROPERTY_RENTAL_INCOME["RED_RENTAL_EXP_ADD_BAL"] = "red-rental-exp-add-bal";
})(PROPERTY_RENTAL_INCOME || (PROPERTY_RENTAL_INCOME = {}));
export var PROPERTY_VALUE_INDEX;
(function (PROPERTY_VALUE_INDEX) {
  PROPERTY_VALUE_INDEX["PURCHASE_PRICE"] = "P";
  PROPERTY_VALUE_INDEX["APPRAISED_VALUE"] = "A";
  PROPERTY_VALUE_INDEX["ESTIMATED_VALUE"] = "E";
})(PROPERTY_VALUE_INDEX || (PROPERTY_VALUE_INDEX = {}));
export var CANADA_PROVINCE;
(function (CANADA_PROVINCE) {
  CANADA_PROVINCE["ALBERTA"] = "Alberta";
  CANADA_PROVINCE["BRITISH_COLUMBIA"] = "British Columbia";
  CANADA_PROVINCE["MANITOBA"] = "Manitoba";
  CANADA_PROVINCE["NEW_BRUNSWICK"] = "New Brunswick";
  CANADA_PROVINCE["NEWFOUNDLAND_AND_LABRADOR"] = "Newfoundland and Labrador";
  CANADA_PROVINCE["NOVA_SCOTIA"] = "Nova Scotia";
  CANADA_PROVINCE["NORTHWEST_TERRITORIES"] = "Northwest Territories";
  CANADA_PROVINCE["NUNAVUT"] = "Nunavut";
  CANADA_PROVINCE["ONTARIO"] = "Ontario";
  CANADA_PROVINCE["PRINCE_EDWARD_ISLAND"] = "Prince Edward Island";
  CANADA_PROVINCE["QU\u00C9BEC"] = "Qu\u00E9bec";
  CANADA_PROVINCE["SASKATCHEWAN"] = "Saskatchewan";
  CANADA_PROVINCE["YUKON"] = "Yukon";
})(CANADA_PROVINCE || (CANADA_PROVINCE = {}));